<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">PROIZVODI NA AKCIJI</h2>
  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <!--
      <div class="odabirDatuma" [style]="{ 'margin-right': '30px' }">
        <label>Datum od:</label>
        <dx-date-box
          [(value)]="datumOd_filter"
          [(max)]="datumDo_filter"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="odabranDatumOd($event)">
        </dx-date-box>
      </div>
      <div class="odabirDatuma">
        <label>Datum do:</label>
        <dx-date-box
          [(value)]="datumDo_filter"
          [(min)]="datumOd_filter"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="odabranDatumDo($event)">
        </dx-date-box>
      </div>
      -->
      <div class="odabirDatuma">
        <label>Odabir tjedna početka:</label>
        <dx-select-box
          [dataSource]="sviTjedni"
          displayExpr="week_in_year"
          valueExpr="week_id"
          [(value)]="tjedanPocetak_filter"
          placeholder="Tjedan početka akcije"
          (onValueChanged)="odabranTjedanOd($event)">
        </dx-select-box>
      </div>
      <div class="odabirDatuma" [style]="{ 'margin-right': '30px' }">
        <label>Odabir tjedna završetka:</label>
        <dx-select-box
          [dataSource]="sviTjedni"
          displayExpr="week_in_year"
          valueExpr="week_id"
          [(value)]="tjedanZavrsetak_filter"
          placeholder="Tjedan završetka akcije"
          (onValueChanged)="odabranTjedanDo($event)">
        </dx-select-box>
      </div>
      <div class="odabirDatuma" [style]="{ 'margin-right': '30px' }">
        <label>Odabir partnera:</label>
        <dx-select-box 
          [dataSource]="partneri"
          displayExpr="naziv"
          valueExpr="id"
          placeholder="Partner"
          [value]="partnerId"
          [showClearButton]="true"
          [searchEnabled]="true"
          [searchExpr]="'naziv'"
          [width]="350"
          (onValueChanged)="odabranPartner($event)">
        </dx-select-box>
      </div>
      <div class="odabirDatuma">
        <label>Odabir proizvoda:</label>
        <dx-select-box 
          [dataSource]="sviProizvodi"
          displayExpr="sifra_i_naziv"
          valueExpr="id"
          placeholder="Proizvod"
          [value]="artiklId"
          [showClearButton]="true"
          [searchEnabled]="true"
          [searchExpr]="['naziv', 'sifra']"
          [width]="600"
          (onValueChanged)="odabranProizvod($event)">
        </dx-select-box>
      </div>
    </div>

    <h2 *ngIf="dohvacanjeAkcija" class="content-block">
      Dohvaćanje proizvoda na akciji...
    </h2>

    <div *ngIf="!dohvacanjeAkcija" class="customTable dnevniPlan">
      <dx-data-grid
        [dataSource]="akcijskiProizvodi"
        [wordWrapEnabled]="true"
        [showColumnLines]="true"
        noDataText="{{ poruka }}"
        keyExpr="id"
        [showBorders]="false"
        (onToolbarPreparing)="onToolbarPreparing($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0">Proizvodi na akciji</h2>
            <p class="mt-0">Praćenje akcijskih proizvoda po datumu</p>
          </div>
          <div class="d-inline ml-15">
            <dx-button
              [disabled]="pravaZaTrenutniPogled != 2"
              icon="plus"
              hint="Dodavanje akcije"
              stylingMode="outlined"
              type="success"
              (click)="dodajAkcijuPopup()"
            >
            </dx-button>
          </div>
        </div>

        <!-- <div *dxTemplate="let data of 'odabirDatuma'">
          <div class="nadzornaDatum">
            <span>Datum</span>
            <dx-date-box
              applyValueMode="useButtons"
              pickerType="calendar"
              displayFormat='dd.MM.yyyy.'
              placeholder="Odaberite tjedan"
              [value]="today"
              [calendarOptions]="{
                firstDayOfWeek: 0
              }"
              [disabledDates]="disableDates"
              (onValueChanged)="promjenaDatuma($event)"
            >
            </dx-date-box>
          </div>
        </div> -->

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxi-column
          dataField="period"
          caption="Trajanje akcije"
          [width]="250"
        ></dxi-column>
        <dxi-column
          dataField="partner"
          caption="Partner"
          [width]="270"
        ></dxi-column>
        <dxi-column
          dataField="poslovnica"
          caption="Poslovnica"
          [width]="150"
        ></dxi-column>
        <dxi-column
          dataField="sifraProizvoda"
          caption="Šifra proizvoda"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="nazivProizvoda"
          caption="Naziv proizvoda"
          [minWidth]="200"
        ></dxi-column>
        <dxi-column
          dataField="kolicina"
          caption="Količina"
          [width]="120"
        ></dxi-column>
        <dxi-column cellTemplate="uredjivanje" [width]="120" alignment="left">
          <div *dxTemplate="let data of 'uredjivanje'">
            <dx-button
              icon="edit"
              hint="Uredi"
              (onClick)="urediAkcijuPopup(data)"
            >
            </dx-button>
            <dx-button
              icon="trash"
              hint="Brisanje djelatnika"
              (onClick)="obrisiAkcijuPopup(data)"
            >
            </dx-button>
          </div>
        </dxi-column>
      </dx-data-grid>
    </div>
  </div>

  <dx-popup
    [width]="700"
    [height]="'auto'"
    [showTitle]="true"
    title="{{ akcijaFormaPoruka }}"
    [dragEnabled]="true"
    [closeOnOutsideClick]="true"
    [position]="{ my: 'top', at: 'center top', of: '', offset: '0 150' }"
    [(visible)]="akcijaPopupVisible"
  >
    <div class="popup-form-wrapper proizvodi-akcija">
      <div class="floating-placeholder">
        <dx-select-box
          [dataSource]="sviProizvodi"
          displayExpr="sifra_i_naziv"
          valueExpr="id"
          placeholder="Odaberite proizvod"
          [value]="odabraniProizvod"
          [searchEnabled]="true"
          [searchExpr]="['naziv', 'sifra']"
          (onValueChanged)="onChangeProizvod($event)"
        >
        </dx-select-box>
      </div>
      <div class="floating-placeholder">
        <dx-select-box
          [dataSource]="sviTjedni"
          displayExpr="week_in_year"
          valueExpr="week_id"
          [(value)]="tjedanPocetak"
          placeholder="Tjedan početka akcije"
          (onValueChanged)="odabranTjedanPocetka($event)">
        </dx-select-box>
      </div>
      <div class="floating-placeholder">
        <dx-select-box
          [dataSource]="sviTjedni"
          displayExpr="week_in_year"
          valueExpr="week_id"
          [(value)]="tjedanZavrsetak"
          placeholder="Tjedan završetka akcije"
          (onValueChanged)="odabranTjedanZavrsetka($event)">
        </dx-select-box>
      </div>
      <div class="floating-placeholder">
        <!--
        <dx-date-box
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          placeholder="Početak akcije"
          displayFormat="'tjedan' ww, dd.MM.YYYY."
          (onValueChanged)="onValueChangedDatumOd($event)"
        >
        </dx-date-box>
        -->
        <dx-date-box
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          placeholder="Početak akcije"
          displayFormat="dd.MM.YYYY."
          [readOnly]="true">
          <!-- (onValueChanged)="odabranDatumPocetka($event)" -->
        </dx-date-box>
      </div>
      <div class="floating-placeholder">
        <!--
        <dx-date-box
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          placeholder="Kraj akcije"
          displayFormat="'tjedan' ww, dd.MM.YYYY."
          (onValueChanged)="onValueChangedDatumDo($event)"
        >
        </dx-date-box>
        -->
        <dx-date-box
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          placeholder="Kraj akcije"
          displayFormat="dd.MM.YYYY."
          [readOnly]="true">
          <!-- (onValueChanged)="odabranDatumZavrsetka($event)" -->
        </dx-date-box>
      </div>
      <div class="floating-placeholder">
        <dx-select-box
          [dataSource]="partneri"
          displayExpr="naziv"
          valueExpr="id"
          placeholder="Odaberite partnera"
          [value]="odabraniPartner"
          (onValueChanged)="onChangePartner($event)"
        >
        </dx-select-box>
      </div>
      <div class="floating-placeholder">
        <dx-select-box
          [dataSource]="poslovnice"
          displayExpr="naziv"
          valueExpr="id"
          placeholder="Odaberite poslovnicu partnera"
          [value]="odabranaPoslovnica"
          (onValueChanged)="onChangePoslovnica($event)"
        >
        </dx-select-box>
      </div>
      <div class="floating-placeholder">
        <dx-number-box
          [value]="kolicina"
          placeholder="Količina"
          (onValueChanged)="onChangeKolicina($event)"
        >
        </dx-number-box>
      </div>
      <!-- <div class="floating-placeholder">
        <dx-text-box
            placeholder="Email"
            [value]="email"
            (onValueChanged)="onChangeEmail($event)"
        >
        </dx-text-box>
    </div>
    <div class="floating-placeholder">
        <dx-number-box
            [value]="cijenaRada"
            placeholder="Cijena rada po satu (kn)"
            (onValueChanged)="onChangeCijenaRada($event)">
        </dx-number-box>
    </div> -->
    </div>

    <dx-button
      *ngIf="akcijaFormaPoruka === 'Dodavanje!'"
      class="dodajButton"
      [disabled]="!odabraniProizvod || !odabraniPartner"
      stylingMode="outlined"
      type="success"
      text="Dodaj"
      (onClick)="dodajAkciju()"
    >
    </dx-button>
    <dx-button
      *ngIf="akcijaFormaPoruka === 'Uređivanje!'"
      class="dodajButton"
      [disabled]="!odabraniProizvod || !odabraniPartner"
      stylingMode="outlined"
      type="success"
      text="Uredi"
      (onClick)="urediAkciju()"
    >
    </dx-button>
  </dx-popup>

  <dx-popup
    [width]="400"
    [height]="'auto'"
    [showTitle]="true"
    title="Brisanje!"
    [dragEnabled]="false"
    [closeOnOutsideClick]="false"
    [position]="{ my: 'top', at: 'center top', of: '', offset: '0 150' }"
    [(visible)]="obrisiAkcijuPopupVisible"
  >
    <p>Jeste li sigurni da želite obrisati akciju?</p>
    <dx-button
      class="dodajButton"
      stylingMode="outlined"
      type="success"
      text="DA"
      (onClick)="obrisiAkciju()"
    >
    </dx-button>
    <dx-button
      class="dodajButton"
      stylingMode="outlined"
      type="danger"
      text="NE"
      (onClick)="obrisiAkcijuPopupVisible = false"
    >
    </dx-button>
  </dx-popup>
</div>
